import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import methods from '../../services/utility';

const OrderPushData = ({ open, closeCallerIdModal, selectMerchant, callers, resetCallers, createNewMerchant, removeCaller }) => {
  const [showNotifBox, setShowNotifBox] = useState(open);
  const { branchId } = useParams();

  useEffect(() => {
    setShowNotifBox(open);
    if (!open) {
      resetCallers();
    }
  }, [open, resetCallers]);

  const selectCaller = (item) => {
    const mappedItem = {
      ...item,
      mobile: item.phoneNumber || "",
      firstName: item.firstname || "",
      lastName: item.lastname || "",
      id: null,
    };
    selectMerchant(mappedItem, item.addresses, item.userId);
    removeCaller(item);
    setShowNotifBox(false);
    closeCallerIdModal();
  };

  const selectToCreateNewMerchant = (item) => {
    const mappedItem = {
      ...item,
      branchId: branchId,
      merchantType: 1,
      firstname: "",
      lastname: "",
      mobile: item.phoneNumber,
    };
    setShowNotifBox(false);
    closeCallerIdModal();
    createNewMerchant(mappedItem);
    removeCaller(item);
  }

  const renderNotification = () => (
    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showNotifBox ? 'block' : 'none' }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content px-3">
          <div className="modal-header">
            <h5 className="modal-title">تماس‌ها</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => { setShowNotifBox(false); closeCallerIdModal(); }}
            ></button>
          </div>
          <div className="modal-body">
            {callers.map((item, index) => (
              <div className='border border-1 rounded-2 p-3 mb-3 shadow card' key={index}>
                <div className='row g-1 '>
                  <div className='col-md-6 col-lg-3 align-content-center'>
                    {item.firstname} {item.lastname}
                  </div>
                  <div className='col-md-6 col-lg-3 align-content-center'>
                    تلفن: {methods.formatPhoneNumber(item.phoneNumber)}
                  </div>
                  <div className='col-md-6 col-lg-2 align-content-center'>
                    {item.userId ? <span>اشتراک {item.merchantCode}</span> : ""}
                  </div>
                  <div className='col-md-6 col-lg-4 text-end'>
                    {item.userId ? "" : <button className='btn btn-green btn-sm' onClick={() => selectToCreateNewMerchant(item)}>ثبت مشتری جدید</button>}
                    <button className='btn btn-purple btn-sm ms-1' onClick={() => selectCaller(item)}>ثبت سفارش</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div >
  );

  return (
    <>
      {renderNotification()}
    </>
  );
}

export default OrderPushData;